import $ from 'jquery';
/* ===============================================================
Navigation
=============================================================== */
class Navigation {
    constructor() {
        this.btnOpen = $('.irantheme-navbar-trigger');
        this.wrapper = $('#irantheme-wrapper');
        this.navigation = $('.irantheme-navigation');
        this.wrapperMask = $('#irantheme-wrapper-mask');
        this.btnClose = $('#irantheme-navigation-close');
        this.togglerMiniProfile = $('.irantheme-mini-profile-toggle');

        // Cache window and document
        this.$window = $(window);
        this.$document = $(document);
        this.$inputElements = $('input, textarea');

        // Cache menu elements
        this.menuParentsLink = this.navigation.find(
            '.irantheme-navigation-menu-ul .menu-item-has-children > a',
        );

        // Throttle variables
        this.resizeTimer = null;
        this.isOpen = false;

        this.events();
    }

    events() {
        // Open handler
        this.btnOpen.on('click', (e) => {
            e.preventDefault();
            if (this.isTriggerDesktop() || this.isTriggerMobile()) {
                this.open();
            }
        });

        // Close handlers
        this.btnClose.on('click', (e) => {
            e.preventDefault();
            this.close();
        });

        this.wrapperMask.on('click', (e) => {
            e.preventDefault();
            this.close();
        });

        // Keyboard navigation
        this.$document.on('keydown', (e) => {
            if (this.isTriggerDesktop() || this.isTriggerMobile()) {
                this.handleKeyPress(e);
            }
        });

        // Menu parent links with event delegation
        this.navigation.on(
            'click',
            '.irantheme-navigation-menu-ul .menu-item-has-children > a',
            (e) => {
                e.preventDefault();
                this.toggleMenu(e);
            },
        );

        // Mini profile toggle with event delegation
        this.togglerMiniProfile.on('click', (e) => {
            e.preventDefault();
            this.toggleMiniProfile(e);
        });

        // Debounced resize handler
        this.$window.on('resize', () => {
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => {
                if (this.$window.outerWidth() > 1199) {
                    this.close();
                }
            }, 100);
        });
    }

    open() {
        if (this.isOpen) return;

        this.btnOpen.addClass('active');
        this.navigation.addClass('active');
        this.wrapperMask.stop(true, true).delay(600).fadeIn();
        this.isOpen = true;
    }

    close() {
        if (!this.isOpen) return;

        this.btnOpen.removeClass('active');
        this.wrapper.removeClass('active');
        this.navigation.removeClass('active');
        this.wrapperMask.stop(true, true).fadeOut(300, () => {
            // Cleanup after animation completes
            this.menuParentsLink.removeClass('active');
            this.menuParentsLink
                .siblings('.sub-menu')
                .stop(true, true)
                .slideUp(250);
        });
        this.isOpen = false;
    }

    handleKeyPress(e) {
        // Early return if input is focused
        if (this.$inputElements.is(':focus')) return;

        const key = e.keyCode || e.which;

        switch (key) {
            case 77: // 'M' key
                if (
                    !this.isOpen &&
                    (this.isTriggerDesktop() || this.isTriggerMobile())
                ) {
                    this.open();
                }
                break;
            case 27: // Escape key
                if (this.isOpen) {
                    this.close();
                }
                break;
        }
    }

    toggleMenu(e) {
        // Robust target detection with multiple fallbacks
        let $target;
        const $clickedElement = $(e.target);

        // Method 1: Direct click on link
        if (
            $clickedElement.hasClass('menu-item-link') ||
            $clickedElement.is('a')
        ) {
            $target = $clickedElement;
        }
        // Method 2: Click inside link
        else if ($clickedElement.closest('.menu-item-link').length) {
            $target = $clickedElement.closest('.menu-item-link');
        }
        // Method 3: Event delegation fallback
        else {
            $target = $(e.currentTarget);
        }

        // Validate we have a proper link element
        if (!$target.length || !$target.is('a.menu-item-link')) {
            return;
        }

        // Get parent li and its siblings at the same level
        const $parentLi = $target.closest('li.menu-item-has-children');
        const $siblings = $parentLi.siblings('li.menu-item-has-children');

        if ($target.hasClass('active')) {
            // Close current menu
            $target.removeClass('active');
            $target.siblings('.sub-menu').stop(true, true).slideUp(250);
        } else {
            // Close sibling menus first
            this.closeSiblingMenus($target, $siblings);

            // Open current menu
            $target.addClass('active');
            $target.siblings('.sub-menu').stop(true, true).slideDown(250);
        }

        // Prevent event bubbling
        e.stopImmediatePropagation();
    }

    closeSiblingMenus($current, $siblings) {
        // Check if there are any active menus at all in this navigation
        const hasAnyActive =
            this.navigation.find('.menu-item-link.active').length > 0;

        if (!hasAnyActive) {
            // Close all menus in this navigation
            this.menuParentsLink.removeClass('active');
            this.menuParentsLink
                .siblings('.sub-menu')
                .stop(true, true)
                .slideUp(250);
        } else {
            // Close only sibling menus
            $siblings.each((index, sibling) => {
                const $siblingLink = $(sibling).children('.menu-item-link');
                const $siblingSubMenu = $(sibling).children('.sub-menu');

                if ($siblingLink.hasClass('active')) {
                    $siblingLink.removeClass('active');
                    $siblingSubMenu.stop(true, true).slideUp(250);
                }
            });
        }
    }

    toggleMiniProfile(e) {
        const $target = $(e.currentTarget);
        $target.toggleClass('active');
        $target
            .siblings('.irantheme-mini-profile-dropdown')
            .stop(true, true)
            .fadeToggle(250);
    }

    isTriggerDesktop() {
        const desktopTriggerMode = this.btnOpen
            .parent()
            .data('trigger-desktop');
        const windowWidth = this.$window.outerWidth();

        return desktopTriggerMode === 'navigation' && windowWidth >= 1200;
    }

    isTriggerMobile() {
        const mobileTriggerMode = this.btnOpen.parent().data('trigger-mobile');
        const windowWidth = this.$window.outerWidth();

        return mobileTriggerMode === 'navigation' && windowWidth < 1200;
    }
}

export default Navigation;
